<template>
    <el-dialog :visible.sync="lableShow" width="738px" :show-close="false" @close="close" center
        :close-on-press-escape="false" :close-on-click-modal="false">
        <div class="lable_popup">
            <div class="lable_title">
                {{ title }}
                <i class="el-icon-close cursor_1" @click="lableShow = false"></i>
            </div>
            <div class="lable_popup8">
                <!-- <div class="cursor_1" :class="lableTitleI == i ? 'lable_popup8_1 lable_popup8_2' : 'lable_popup8_1'"
                    v-for="(item, i) in lableTitle" :key="i" @click="changeTitle(i, item)">
                    {{ item }}
                    <div v-if="lableTitleI == i" class="lable_popup8_3"></div>
                </div> -->
                <tabsLable v-model="lableTitleI" :tabs="lableTitle" @change="changeTitle" />
            </div>
            <div class="lable_popup1" ref="scrollContainer" @scroll="handleScroll">
                <div class="lable_popup1_1" v-for="(item, i) in lableList" :key="i">
                    <div class="lable_popup1_2" :ref="`lable${i}`">{{ item.paramName }}</div>
                    <div class="lable_popup1_3">
                        <div class="cursor_1" :class="lable.select ? 'lable_popup200 lable_popup3' : 'lable_popup200'"
                            v-for="(lable, l) in item.placeholder" :key="l" @click="select(i, l, lable.name)">
                            {{ lable.name }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="lable_popup4">
                <el-input v-model="input" maxlength="20" show-word-limit placeholder="请输入自定义类型"></el-input>
            </div>
            <div class="lable_popup5">
                <div class="lable_popup6">{{ lableI.length + customizeL.length }}/1</div>
                <div class="lable_popup7 cursor_1" ref="confirmBtn" tabindex="0" @keydown.enter="handleEnterKey"
                    @click="confirm">确认
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import api from '@/api/api';
import tabsLable from '@/components/dongeb/tabsLable.vue';
export default {
    components: {
        tabsLable
    },
    props: {
        title: {
            type: String,
            default: '作品类型'
        }
    },
    data() {
        return {
            lableShow: false, //标签选择弹框显示
            lableTitle: [], //标签头部
            lableTitleI: 0,//标签头部下标
            lableList: [], //所有标签
            lableI: [], //选中标签
            customizeL: [], //自定义标签
            lableTop: [],
            input: '',
            isScrolling: true, //是否滚动
            selectLableType: '',//当前选中标签类型
        }
    },
    watch: {
        input: {
            handler(newVal) {
                if (newVal) {
                    //  this.customizeL = [this.selectLableType + '-' + newVal]
                    this.customizeL = ['自定义-' + newVal]
                    this.lableList.forEach(item => {
                        item.placeholder.forEach(placeholderItem => {
                            placeholderItem.select = false
                        });
                    });
                    this.lableI = []
                } else {
                    this.customizeL = []
                }
            },
            immediate: true
        }
    },
    methods: {
        openLable(data) {
            // console.log(data)
            this.getLable()
            setTimeout(() => {
                if (this.lableList.length) {
                    let found = false
                    if (!data) {
                        if (this.lableList && this.lableList.length > 0) {
                            this.selectLableType = this.lableList[0].paramName
                        }
                    }

                    this.lableList.forEach(item => {
                        item.placeholder.forEach(placeholderItem => {
                            let name = ''
                            if (data) {
                                if (data.indexOf('-') != -1) {
                                    name = item.paramName + '-' + placeholderItem.name
                                } else {
                                    name = placeholderItem.name
                                }
                                if (name === data) {
                                    placeholderItem.select = true
                                    this.selectLableType = item.paramName
                                    found = true
                                    this.lableI.push(item.paramName + '-' + placeholderItem.name)
                                }
                            }
                        });
                    });
                    if (!found && data) {
                        if (data.indexOf('-') != -1) {
                            // this.selectLableType = data.split('-')[0]
                            this.input = data.split('-')[1]
                        } else {
                            this.input = data
                        }
                    }

                    this.lableList.map((item, i) => {
                        this.lableTop.push(this.$refs[`lable${i}`][0].offsetTop)
                    })
                }
            }, 100)
            this.lableShow = true
        },
        // 切换title
        changeTitle(i, name) {
            this.isScrolling = false
            const scrollContainer = this.$refs.scrollContainer;
            const lable = this.$refs[`lable${i}`];
            if (lable) {
                this.selectLableType = name
                const lableOffsetTop = lable[0].offsetTop - 147;
                scrollContainer.scrollTop = lableOffsetTop;
            }
            this.lableTitleI = i
        },
        // 获取类型
        getLable() {
            api.getParameter('pcxscs', 'style').then((res) => {
                if (res.code == 200) {
                    res.data[0].children.map((item) => {
                        this.lableTitle.push(item.paramName)
                        item.placeholder = item.placeholder.split(',').map((label) => ({
                            select: false,
                            name: label
                        }))
                    })
                    this.lableList = res.data[0].children
                }
            })
        },
        // 选择类型
        select(i, l, name) {
            this.lableList.forEach(item => {
                item.placeholder.forEach(subItem => {
                    if (name === subItem.name) {
                        if (subItem.select == false) {
                            subItem.select = true
                            this.input = ''
                            this.customizeL = []
                        } else {
                            subItem.select = false
                        }
                    } else {
                        subItem.select = false
                    }
                })
            })
            let data = this.lableList.map(lable => lable.placeholder.filter(item => item.select).map(item => lable.paramName + '-' + item.name))
            this.lableI = [].concat(...data)
            // console.log(this.lableI)
        },
        // 确认
        confirm() {
            if (this.input) {
                //    this.customizeL = [this.selectLableType + '-' + this.input]
                this.customizeL = ['自定义-' + this.input]
            } else {
                this.customizeL = []
            }
            let a = this.lableI.concat(this.customizeL)
            if ((a.length) < 1) {
                this.$emit('getLable', '')
            } else {
                this.$emit('getLable', a[0])
            }
            this.close()
        },
        // 关闭
        close() {
            this.lableShow = false
            this.lableTitle = []
            this.lableI = []
            this.customizeL = []
            this.input = ''
        },
        handleScroll() {
            const scrollContainer = this.$refs.scrollContainer;
            const currentScrollTop = scrollContainer.scrollTop;
            this.lableTop.map((item, i) => {
                if (currentScrollTop + 147 >= item) {
                    if (this.isScrolling) {
                        this.lableTitleI = i
                    }

                }
            });
        }

    }
}
</script>

<style>
#novel_create .el-dialog__header,
#novel_create .el-dialog__header {
    padding: 0;
}

#novel_create .el-dialog__body,
#novel_create .el-dialog__body {
    padding: 0;
    background-color: transparent !important;
}

#novel_create .el-dialog,
#novel_create .el-dialog {
    background-color: transparent !important;
    box-shadow: none;
}

.cursor_1:hover {
    opacity: 0.8;
}

.lable_popup {
    width: 738px;
    padding-bottom: 20px;
    border-radius: 12px;
    background-color: #FFFFFF;
    overflow: hidden;
}

.lable_title {
    width: 100%;
    height: 75px;
    font-size: 19px;
    color: #111111;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #F5F7FA;
    padding: 0 42px;
}

.lable_popup1 {
    width: 738px;
    max-height: 200px;
    padding: 0 40px;
    margin: 20px 0 5px 0;
    overflow: auto;
    -ms-overflow-style: none;
    /* IE和Edge浏览器下隐藏滚动条 */
    scrollbar-width: none;
    /* Firefox下隐藏滚动条 */
}

.lable_popup1_2 {
    margin-bottom: 13px;
}

.lable_popup1_3 {
    display: flex;
    flex-flow: wrap;
}



.lable_popup3 {
    border: 1px solid var(--tech-primary);
    color: var(--tech-primary);
}

.lable_popup4 {
    width: 738px;
    padding: 0 40px;
}

.lable_popup5 {
    width: 738px;
    padding: 0 40px;
    display: flex;
    align-items: center;
    margin-top: 20px;
    justify-content: space-between;
}

.lable_popup6 {
    font-size: 13px;
    color: #333333;
    font-weight: 400;
}

.lable_popup7 {
    width: 100px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    background-color: var(--tech-primary);
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 400;
    border-radius: 8px;
}

.lable_popup8 {
    width: 738px;
    overflow-x: scroll;
    white-space: nowrap;
    -ms-overflow-style: none;
    /* IE和Edge浏览器下隐藏滚动条 */
    scrollbar-width: none;
    /* Firefox下隐藏滚动条 */
    display: flex;
    align-items: center;
    height: 52px;
    padding: 0 0px;
    border-bottom: 1px solid #EBEFF4;
}

.lable_popup8_1 {
    font-weight: 400;
    font-size: 17px;
    color: #666666;
    margin-right: 33px;
    position: relative;
}

.lable_popup8_2 {
    color: #111111;
    font-weight: bold;
}

.lable_popup8_3 {
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translate(-50%);
    width: 17px;
    height: 4px;
    background: #FF6603;
    border-radius: 0px 0px 0px 0px;
}
</style>